export default __webpack_public_path__ + "static/media/DogByte_Paw.225a87f1.svg";